export default __webpack_public_path__ + "static/media/aboutimg2.9bb57093.webp";